import React, { useEffect, useState } from "react";
import styles from "./MultipleScoreComponent.module.scss";
import { InputLabel, TextField, Tooltip } from "@mui/material";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useDispatch } from "react-redux";
import { setWeight } from "redux/slices/scoringSlice";
import { capitalizeFirstLetter, truncateText } from "utils/utils";
import toast from "react-hot-toast";

const MultipleScoreComponent = ({ handleDelete, item, initialValues = {} }) => {
  const [scores, setScores] = useState(Object.fromEntries((item?.options || item?.option )?.map(value => [value, 0])));
  const dispatch = useDispatch();

  const modifiedOptionsWithWieghtAndmaxWeight = (updatedScores) => {
    const options = Object?.entries(updatedScores)?.reduce((acc, cr) => {
      const [option, score] = cr;
      acc?.push({
        option: capitalizeFirstLetter(option),
        score: Number(score),
      });
      return acc;
    }, []);

    const maxWeight = options.reduce((max, current) => {
      return current.score > max ? current.score : max;
    }, -Infinity);

    return { maxWeight, options };
  };

  // Handle input change for scores
  const handleInputChange = (field, value) => {
    let updatedScores = { ...scores };

    if (!value && value !== 0) {
      toast.error("Please enter only valid numbers");
    }

    updatedScores = { ...scores, [field]: value };
    setScores(updatedScores);

    const { options, maxWeight } =
      modifiedOptionsWithWieghtAndmaxWeight(updatedScores);

    dispatch(
      setWeight({
        type: "field",
        fieldId: item?.fieldId,
        scoreType: "byOptions",
        options: [...options],
        maxWeight: maxWeight,
      })
    );
  };

  useEffect(() => {
    if (!item?.options?.length) {
      const { options, maxWeight } =
        modifiedOptionsWithWieghtAndmaxWeight(scores);

      dispatch(
        setWeight({
          type: "field",
          fieldId: item?.fieldId,
          scoreType: "byOptions",
          options: [...options],
          maxWeight: maxWeight,
        })
      );
    } else {
      let temp = item?.options?.reduce((acc, cr) => {
        acc[cr.option] = cr?.score || "0"
        return acc
      }, {})
      setScores(temp)
    }
  }, [item]);

  return (
    <div className={styles?.scoreContainer}>
      <div className={styles?.header}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Tooltip title={item?.name}>
            <span>{truncateText(item?.name || "", 50)}</span>
          </Tooltip>
          <Tooltip title={"Assign a value to each choice below."}>
            <InfoOutlinedIcon
              fontSize="small"
              sx={{ color: "#3e9ef7", cursor: "pointer" }}
            />
          </Tooltip>
        </div>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => handleDelete(item.id, item?.fieldId)}
        >
          <HighlightOffOutlinedIcon
            sx={{ color: "#3e9ef7" }}
            fontSize="medium"
          />
        </span>
      </div>

      <div className={styles?.options}>
        {
          item?.options?.length ? item?.options?.map((option) => {
            return <div>
              <InputLabel>{option?.option}</InputLabel>
              <TextField
                size="small"
                type="number"
                value={scores[option?.option]}
                onChange={(e) => handleInputChange(option?.option, e.target.value)}
                onBlur={(e) => !e.target.value && handleInputChange(option?.option, 0)}
              />
            </div>
          }) :
            item?.option?.map((option) => {
              return <div>
                <InputLabel>{option}</InputLabel>
                <TextField
                  size="small"
                  type="number"
                  value={scores[option]}
                  onChange={(e) => handleInputChange(option, e.target.value)}
                  onBlur={(e) => !e.target.value && handleInputChange(option, 0)}
                />
              </div>
            })
        }

        {/* <div>
          <InputLabel>Yes</InputLabel>
          <TextField
            size="small"
            type="number"
            value={scores.yes}
            onChange={(e) => handleInputChange("yes", e.target.value)}
            onBlur={(e) => !e.target.value && handleInputChange("yes", 0)}
          />
        </div>
        <div>
          <InputLabel>No</InputLabel>
          <TextField
            size="small"
            type="number"
            value={scores.no}
            onChange={(e) => handleInputChange("no", e.target.value)}
            onBlur={(e) => !e.target.value && handleInputChange("no", 0)}
          />
        </div>
        <div>
          <InputLabel>Maybe</InputLabel>
          <TextField
            size="small"
            type="number"
            value={scores.maybe}
            onChange={(e) => handleInputChange("maybe", e.target.value)}
            onBlur={(e) => !e.target.value && handleInputChange("maybe", 0)}
          />
        </div> */}
      </div>
    </div>
  );
};

export default MultipleScoreComponent;
